<template>
  <v-flex xs12 mb-3 :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-0': $vuetify.breakpoint.mdAndUp}">
    <!-- CASE DATA VIEW -->
      <v-flex v-for="(row, ib) in schemaRows" :key="ib" :id="ib.toString()">
        <!-- Multi column -->
        <v-flex py-0 pb-2 mb-2>
          <v-layout xs12 lg6 row>
            <v-flex xs12 lg12 v-for="(fieldset, ic) in row" :key="ic" class="fieldset-container2-test" :id="fieldset.name">
              <v-layout
                xs12 column fill-height
                style="background:white !important"
                class="mb-1 rounded-3"
                :class="formFurniture(ic)"
                >
                <h2 class="mb-4">{{fieldsetName(fieldset)}}</h2>
                <v-flex>
                  <v-flex v-for="(field, jc) in fieldsFor(fieldset)" :key="jc">
                    <v-flex>
                      <component
                        :is="getFieldComponent(field)"
                        :field="field"
                        :id="field.name"
                        :data="caseValues[field.name]"
                        :ref=" `_fieldkey-${field.name}`"
                        :caseType="caseType"
                        :newCase="newCase"
                        v-on:add-new-row-to-table="addNewRowToTable"
                        v-on:update-item="updateData"
                        v-on:blurred="blurred">
                      </component>
                    </v-flex>
                  </v-flex>
                </v-flex>

                <v-flex class="text-right" v-if="summaryFieldTaskButtons[fieldset.name]">
                  <v-btn
                    v-for="(taskButton, index) in summaryFieldTaskButtons[fieldset.name]"
                    :key="index"
                    class="mr-0"
                    color="secondary"
                    style="float:right"
                    @click="taskButtonExecute(taskButton.id)"
                  >
                    {{ taskButton.name }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>

          </v-layout>
        </v-flex>
        <!-- End Multi column -->
      <!-- End row loop -->
    </v-flex>
    <!-- End of CaseDataView -->
    <v-layout v-if="newCase" row wrap>
      <v-btn @click="saveCase()" color="success" class="ml-0 mt-2"  v-if="!showJumpToMenu">Save changes</v-btn>
    </v-layout>
  </v-flex>
</template>

<script>
import RichText from "@/components/cases/case-elements/RichText.vue"
import TextField from "@/components/cases/case-elements/TextField.vue"
import CurrencyField from "@/components/cases/case-elements/CurrencyField.vue"
import NumberField from "@/components/cases/case-elements/NumberField.vue"
import TextArea from "@/components/cases/case-elements/TextArea.vue"
import CheckBox from "@/components/cases/case-elements/CheckBox.vue"
import SelectField from "@/components/cases/case-elements/SelectField.vue"
import StateSelector from "@/components/cases/case-elements/StateSelector.vue"
import CascadingOptionsField from "@/components/cases/case-elements/CascadingOptionsField.vue"
import BooleanField from "@/components/cases/case-elements/BooleanField.vue"
import AddressField from "@/components/cases/case-elements/AddressField.vue"
import DateField from "@/components/cases/case-elements/DateField.vue"
import RelationField from "@/components/cases/case-elements/RelationField.vue"
import DocumentField from "@/components/cases/case-elements/DocumentField.vue"
import EmbeddedTable from "@/components/cases/case-elements/EmbeddedTable.vue"
import LocationField from "@/components/cases/case-elements/LocationField.vue"
import PasswordField from "@/components/cases/case-elements/PasswordField.vue"
import UrlField from "@/components/cases/case-elements/UrlField.vue"

import Helpers from "@/helpers.js"
import { mapState } from "vuex"
import Vue from "vue"

const displayToggled = (field, caseValues) => !field.display_toggle_field || (field.display_toggle_field && caseValues[field.display_toggle_field])

export default {
  name: "FieldsetContainer2",
  components: {
    RichText,
    TextField,
    TextArea,
    CurrencyField,
    NumberField,
    CheckBox,
    SelectField,
    StateSelector,
    BooleanField,
    AddressField,
    DateField,
    RelationField,
    DocumentField,
    EmbeddedTable,
    CascadingOptionsField,
    LocationField,
    PasswordField,
    UrlField
  },
  data: () => ({ dialogDelete: false }),
  props: {
    newCase: {
      type: Boolean,
      default: false
    },
    caseData: Object,
    dirtyFields: {
      type: Object,
      default: () => ({})
    },
    caseType: {
      type: Object,
      required: true
    },
    relationFieldMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      isAdminMode: state => state.currentUser.isAccountAdmin,
      lastCaseContainerPath: state => state.ui.lastCaseContainerPath,
      caseTypes: state => state.caseTypes.all,
      permissions: state => state.ui.grantedPermissions,
      showJumpToMenu: state => state.ui.keepMainMenuExpanded
    }),
    defaultView() {
      return !this.schema.case_data_views
    },
    schema() {
      return this.caseType.currentSchema
    },
    hasPermission() {
      if (this.isAdminMode) { return true }
      const perm = "Delete-" + Helpers.formatSnakeCase(this.caseType.name)
      return (this.permissions.includes(perm))
    },
    schemaRows() {
      const fieldsetList = []
      const caseDataView = this.newCase ? 'new' : 'edit'
      if (this.schema.case_data_views && this.schema.case_data_views[caseDataView] && this.schema.case_data_views[caseDataView].rows) {
        for (const row of this.schema.case_data_views[caseDataView].rows) {
          const fieldSetRow = []
          for (const column of row.columns) {
            const fieldsetName = column.fieldset
            const displayableFieldset = this.getDisplayableFieldset(fieldsetName)
            if (displayableFieldset) {
              fieldSetRow.push(displayableFieldset)
            }
          }
          if (fieldSetRow.length > 0) {
            fieldsetList.push(fieldSetRow)
          }
        }
      } else {
        for (const fs of this.schema.fieldsets) {
          if (!fs.display_toggle_field || (fs.display_toggle_field && this.caseValues[fs.display_toggle_field])) {
            fieldsetList.push([fs])
          }
        }
      }

      this.$emit("fieldset-list-updated", { fieldsetList })
      return fieldsetList
    },
    caseValues() {
      const data = this.caseData.properties
      data.title = this.caseData.title

      for (const fieldset of this.schema.fieldsets) {
        for (const field of fieldset.fields) {
          if (field.type === 'entity' && !this.caseData.properties[field.name]) {
            this.caseData.properties[field.name] = []
          }
        }
      }
      return data
    },
    summaryFieldTaskButtons() {
      if (!this.newCase) {
        const summaryFieldTaskButtons = []

        if (this.caseData && this.caseData.tasklists && Array.isArray(this.caseData.tasklists)) {
          const tasklists = this.caseData.tasklists

          tasklists.forEach((tasklist) => {
            if (tasklist && tasklist.tasks && Array.isArray(tasklist.tasks)) {
              const fieldsetTasks = tasklist.tasks.filter(t => t && t.task && t.task.fieldset)

              fieldsetTasks.forEach(fieldsetTask => {
                if (fieldsetTask) {
                  const fieldset = summaryFieldTaskButtons[fieldsetTask.task.fieldset]
                  if (fieldset) {
                    fieldset.push(fieldsetTask)
                  } else {
                    summaryFieldTaskButtons[fieldsetTask.task.fieldset] = [fieldsetTask]
                  }
                }
              })
            }
          })
        }
        return summaryFieldTaskButtons
      } else {
        return []
      }
    }
  },
  methods: {
    saveCase() {
      this.$emit("save")
    },
    formFurniture(index) {
      if (index === 0) {
        return this.relationFieldMode ? "" : "pa-4 px-4 py-4 elevation-2"
      } else {
        return this.relationFieldMode ? "pl-2" : "pa-4 px-4 py-4 elevation-2"
      }
    },
    fieldsFor(fieldset) {
      return (fieldset.fields || []).filter(field => displayToggled(field, this.caseValues) && !field.hidden)
    },
    getDisplayableFieldset(fieldsetName) {
      const fs = this.getFieldset(fieldsetName)
      if (fs && (!fs.display_toggle_field || (fs.display_toggle_field && this.caseValues[fs.display_toggle_field]))) {
        return fs
      }
    },
    key(field) {
      return `_fieldkey-${field.name}`
    },
    async deleteCase() {
      this.dialogDelete = false
      const result = await this.$store.dispatch('deleteCase', parseInt(this.caseData.id))
      if (result) {
        if (this.lastCaseContainerPath && this.lastCaseContainerPath.length > 0) {
          this.$router.push(this.lastCaseContainerPath.pop())
        } else {
          this.$router.push({ name: "Dashboard" })
        }
      }
    },
    recordDirtyField(field, row, table) {
      const dirtyRow = (row !== null && row !== undefined) ? row : -1

      if (table) {
        if (!this.dirtyFields[table]) {
          this.dirtyFields[table] = {}
        }

        if (this.dirtyFields[table][field]) {
          if (!this.dirtyFields[table][field].includes(dirtyRow)) {
            this.dirtyFields[table][field].push(dirtyRow)
          }
        } else {
          this.dirtyFields[table][field] = [dirtyRow]
        }
      } else {
        if (this.dirtyFields[field]) {
          if (!this.dirtyFields[field].includes(dirtyRow)) {
            this.dirtyFields[field].push(dirtyRow)
          }
        } else {
          this.dirtyFields[field] = [dirtyRow]
        }
      }
    },
    addNewRowToTable(fieldName) {
      if (!this.caseData.properties[fieldName]) {
        this.caseData.properties[fieldName] = []
      }
      this.caseData.properties[fieldName].push({})

      if (!this.dirtyFields[fieldName]) {
        this.dirtyFields[fieldName] = {}
      }
      Vue.set(this.caseData.properties, fieldName, [...this.caseData.properties[fieldName]])

      const fieldKey = `_fieldkey-${fieldName}`
      this.$refs[fieldKey][0].$forceUpdate()

      if (!this.relationFieldMode) {
        this.$store.dispatch('caseFieldsUpdated', { caseData: this.caseData, field: fieldName, row: {}, table: this.caseData.properties[fieldName] })
      }
    },
    updateData(value) {
      if (value) {
        const { field, row, table } = value


        if (row === null || row === undefined) {

          if (this.caseData.properties[value.field]!==value.data) {
            this.recordDirtyField(field, row, table)
            Vue.set(this.caseData.properties, value.field, value.data)
          }

        } else if (row && table) {

          if (this.caseData.properties[table][row][field]!==value.data) {
            this.recordDirtyField(field, row, table)
            this.caseData.properties[table][row][field] = value.data
          }

        }
      }
    },
    blurred({ field, row, table, providedCaseData }) {
      if (!providedCaseData) {
        providedCaseData = this.caseData
      }
      if (!this.relationFieldMode) {
        if (table) {
          if (this.dirtyFields[table] && this.dirtyFields[table][field]) {
            this.$store.dispatch('caseFieldsUpdated', { caseData: providedCaseData, field, row, table })
          }
        } else if (this.dirtyFields[field]) {
          this.$store.dispatch('caseFieldsUpdated', { caseData: providedCaseData, field })
        }
      }
    },
    fieldsetName(fieldset) {
      const name = fieldset.display_name ? fieldset.display_name : Helpers.capitalizeRemoveUnderscores(fieldset.name)
      return name
    },
    getFieldset(name) {
      if (this.caseData) {
        return this.schema.fieldsets.find(fieldset => fieldset.name.toLowerCase() === name.toLowerCase())
      }
    },
    getFieldComponent(field) {
      switch (field.type.toLowerCase()) {
        case "string":
          switch (field.display) {
            case "text":
              return "TextArea"
            case "richtext":
              return "RichText"
            case "select":
              if (field.cascading_options === null) {
                return "SelectField"
              } else {
                return "CascadingOptionsField"
              }
            case "url":
              return "UrlField"
            default:
              return "TextField"
          }
        case "number":
          if (field.display === "currency") {
            return "CurrencyField"
          } else {
            return "NumberField"
          }
        case "boolean":
          if (field.display === "checkbox") {
            return "CheckBox"
          } else {
            return "BooleanField"
          }
        case "date":
          return "DateField"
        case "entity":
          if (!this.relationFieldMode) {
            return "EmbeddedTable"
          } else {
            return
          }
        case "relation":
          return "RelationField"
        case "document":
          if (!this.newCase) {
            return "DocumentField"
          } else {
            return
          }
        case "address":
          return "AddressField"
        case "email_address":
          return "TextField"
        case "password":
          return "PasswordField"
        case "case_type_states":
          if (!this.caseTypes || this.caseTypes.length === 0) {
            this.$store.dispatch('reloadCaseTypes')
          }
          return "StateSelector"
        case "location":
          return "LocationField"
        default:
        // console.error("Unknown type! " + JSON.stringify(field))
      }
    },
    async taskButtonExecute(taskId) {
      if (taskId) {
        const result = await this.$store.dispatch("executeCaseTask", taskId)
        if (result) {
          this.$store.dispatch("getCurrentlySelectedCaseProperties", { caseId: this.caseData.id })
        }
      }
    }
  }
}
</script>